import { render, staticRenderFns } from "./OnlineStudent.vue?vue&type=template&id=2e430414&scoped=true&"
import script from "./OnlineStudent.vue?vue&type=script&lang=js&"
export * from "./OnlineStudent.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/project-detail.css?vue&type=style&index=0&id=2e430414&scoped=true&lang=css&"
import style1 from "./OnlineStudent.vue?vue&type=style&index=1&id=2e430414&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e430414",
  null
  
)

export default component.exports